import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';

import { DesignSystemHelperService, PromoDesignSystemConfiguration } from '@frontend/promo-utils';
import { DsBadge } from '@frontend/ui/badge';
import { DsNotificationBubble } from '@frontend/ui/notification-bubble';
import { LetDirective } from '@ngrx/component';
import { Observable } from 'rxjs';

import { Offer } from '../../offers/models';
import { OfferContentConfiguration } from '../../offers/offer-content.client-config';
import { LoadOffersApiService } from '../../offers/offers-service/load-offers.service';

@Component({
    selector: 'offer-type-badge',
    templateUrl: 'offer-type-badge.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LetDirective, NgClass, DsBadge, DsNotificationBubble],
})
export class OfferTypeBadgeComponent implements OnChanges {
    @Input() offer: Offer;
    @Input() groupedOffersCount: any;
    vm$: Observable<any>;
    showOfferType: boolean;
    offerBadgeClass: string = 'badge-product ';
    dsBadge: any;
    dsNotificationBubble: any;
    constructor(
        private loadOffersApiService: LoadOffersApiService,
        public offerContentConfiguration: OfferContentConfiguration,
        private designSystemHelperService: DesignSystemHelperService,
        private designSystemConfig: PromoDesignSystemConfiguration,
    ) {
        this.vm$ = this.loadOffersApiService.offerTeaserClientContent$;
    }

    ngOnChanges() {
        this.dsConfigSettings();
        this.isOfferWithTypeLabel();
    }

    isOfferWithTypeLabel(): void {
        if (
            this.offer?.offerContent?.offerType != null &&
            Object.keys(this.offer?.offerContent?.offerType)?.length > 0 &&
            this.offer?.offerContent?.offerType?.text != ''
        ) {
            this.showOfferType = true;
            this.offerBadgeClass += this.offer.offerContent.offerType.cssClass;
        }
    }

    dsConfigSettings() {
        this.dsBadge = this.designSystemHelperService.getDsComponentsList()?.dsBadges;
        if (
            this.offer?.offerMetadata?.serviceType &&
            this.designSystemConfig?.dsNotificationBubble['badges-' + this.offer?.offerMetadata?.serviceType]
        )
            this.dsNotificationBubble = this.designSystemHelperService.getDsConfig(
                this.designSystemConfig?.dsNotificationBubble['badges-' + this.offer?.offerMetadata?.serviceType],
                true,
            );
        else this.dsNotificationBubble = this.designSystemHelperService.getDsComponentsList('badges-default')?.dsNotificationBubble;
    }
}
